(function($) { "use strict";
	// section-shop-archive
	if( $('.block-membership').length ) {
		//onclick of add-to-button disable button
		$('.block-membership button.add-to-basket').on('click', function (e){
			//hide clicked button
			$(this).hide();

			//show 'Please Wait...'
			$(this).siblings('.loading').show();
		});


		//spektrix events
		$('.block-membership spektrix-memberships').each(function(){
			$(this).on('success', function(e){
				//hide 'Please Wait...'
				$(this).find('.loading').hide();
				// console.log('event jq success', e)
			});
			$(this).on('fail', function(e){
				//hide 'Please Wait...'
				$(this).find('.loading').hide();

				//re-show the button
				$(this).find('button.add-to-basket').show();
				// console.log('event jq fail', e)
			});
		});
	}
})(jQuery);
